import Vue from 'vue';
import Router from 'vue-router';

// Containers
import Full from '../containers/Full.vue';

// Views
import Login from '../views/Login.vue';
import SelectSystem from '../views/SelectSystem.vue';
import Home from '../views/Home.vue';
import Device from '../views/Device.vue';
import Shunting from '../views/Shuntting.vue';
import Notifications from '../views/Notifications.vue';
import Messages from  '../views/Messages.vue';
import Events from '../views/Events.vue';
import Maximeter from '../views/Maximeter.vue';
import ExportData from '../views/ExportData.vue';
import EnergeticInform from '../views/EnergeticInform.vue'
import CostsInform from '../views/CostsInform.vue';
import InvoiceSimulation from '../views/InvoiceSimulation.vue';
import InfoApp from '../views/InfoApp.vue';
import Profile from '../views/Profile.vue';
import Settings from '../views/Settings.vue';
import CabalTemp from '../views/CabalTemp.vue';
import AnuallSumary from '../views/AnuallSumary.vue';

Vue.use(Router);

export default new Router({
  mode: 'hash',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/home',
      name: 'Seleccionar Sistema',
      component: Full,
      children: [
         {
          path: '/',
          name: '',
          component: SelectSystem
        },
        {
          path: 'home',
          name: 'Home',
          component: Home
        },
        {
          path: 'device',
          name: 'Device',
          component: Device
        },
        {
          path: 'shunting',
          name: 'Shunting',
          component: Shunting
        },
        {
          path: 'notifications',
          name: 'Notifications',
          component: Notifications
        },
        {
          path: 'messages',
          name: 'Messages',
          component: Messages
        },
        {
          path: 'events',
          name: 'Events',
          component: Events
        },
        {
          path: 'maximeter',
          name: 'Maximeter',
          component: Maximeter
        },
        {
          path: 'export_data',
          name: 'ExportData',
          component: ExportData
        },
        {
          path: 'energetic_inform',
          name: 'EnergeticInform',
          component: EnergeticInform
        },
        {
          path: 'costs_inform',
          name: 'CostsInform',
          component: CostsInform
        },
        {
          path: 'invoice_simulation',
          name: 'InvoiceSimulation',
          component: InvoiceSimulation
        },
        {
          path: 'anuall_sumary',
          name: 'AnuallSumary',
          component: AnuallSumary
        },
        {
          path: 'info',
          name: 'InfoApp',
          component: InfoApp
        },
        {
          path: 'profile',
          name: 'Profile',
          component: Profile
        },
        {
          path: 'settings',
          name: 'Settings',
          component: Settings
        }
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/cabal_temp',
      name: 'CabalTemp',
      component: CabalTemp
    },
    {
      path: '/select_system',
      name: 'SelectSystem',
      component: SelectSystem
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js